export default "__VITE_ASSET__y2bSgDRVzAnvmDAjex8c5Q__"